import apiClient from "QueryClient/axiosClient";

export const findCollegesApi = (data) => {
  return apiClient.post("/collegeFinder/generateRecommendations", data);
};

export const updateCollegeFinderDetails = (data) => {
  return apiClient.put("/users/updateCollegeFinderDetails", data);
};
